import { css } from '@emotion/react'

import { radii } from 'src/theme/radii'

export const sessionItemCss = css`
  padding: 1.2rem;
  border-radius: ${radii.md};
`
